import { useCallback, useMemo } from "react";
import { useFolderTreeSortMode } from "./useFolderTreeSortMode.js";
function useTreeSortModeHandlers() {
    const { handleSortCancel, handleSortClick } = useFolderTreeSortMode();
    const resolveBuiltInToolbarAction = useCallback((action, _buttonId)=>{
        if (action !== "sort") {
            return {};
        }
        return {
            onClick: handleSortClick,
            onCancel: handleSortCancel
        };
    }, [
        handleSortCancel,
        handleSortClick
    ]);
    return useMemo(()=>({
            resolveBuiltInToolbarAction
        }), [
        resolveBuiltInToolbarAction
    ]);
}
export { useTreeSortModeHandlers };
